module.exports = __webpack_public_path__ + "08499ef52ca60ea1f1792aa9f97e310f.pdf";